import { createFileRoute, redirect } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { DayStart } from "@/features/dashboard/DayStart";
import { ForYouStrip } from "@/features/dashboard/ForYouStrip";
import { WorkQueues } from "@/features/dashboard/WorkQueues";
import { hasModule, firstAllowedRoute } from "@/lib/auth";

export const Route = createFileRoute("/_shell/dashboard")({
  // Dashboard is also the fallback landing spot; only bounce when another
  // module IS allowed (a zero-module user stays here — harmless placeholder).
  beforeLoad: ({ context }) => {
    if (!hasModule(context.session, "dashboard")) {
      const target = firstAllowedRoute(context.session);
      if (target !== "/dashboard") throw redirect({ to: target });
    }
  },
  component: DashboardScreen,
});

function DashboardScreen() {
  const { t } = useTranslation();
  const { session } = Route.useRouteContext();

  const canCalendar = hasModule(session, "calendar");
  const canTasks = hasModule(session, "tasks");
  const canMail = hasModule(session, "mail");
  const anything = canCalendar || canTasks || canMail;

  return (
    <div className="wl-page" data-screen-label="Back-office Dashboard">
      {/* Above everything else, including the agenda: a colleague waiting on an
          answer outranks any date somebody set for themselves. Renders nothing
          when there is nothing waiting. */}
      {canTasks && <ForYouStrip />}

      {/* Every work queue of every world you see, with what waits in it (navigatie ronde 2, N7). */}
      <div style={{ marginBottom: "var(--space-6)" }}>
        <WorkQueues />
      </div>

      {anything ? (
        <DayStart canCalendar={canCalendar} canTasks={canTasks} canMail={canMail} />
      ) : (
        <div className="wl-card" style={{ padding: "var(--space-8)", textAlign: "center" }}>
          <p className="t-body t-muted">{t("dashboard.noModules")}</p>
        </div>
      )}
    </div>
  );
}
